export default "__VITE_ASSET__ClIPOTMD__"